import angular from 'angular';
import _ from 'lodash';

angular.module('webTools').service('DropHandler', ['$q',
    function ($q) {
        return {
            getFiles: function (dataTransfer) {
                var defer = $q.defer();
                var folderDefer = $q.defer();

                var files = [];
                var items = dataTransfer.items;
                var entryCount = 0;

                var fileReadSuccess = function (file, fullPath) {
                    file.relativePath = fullPath.substring(1);
                    files.push(file);
                    entryCount--;

                    if (entryCount === 0) {
                        folderDefer.resolve();
                    }
                };

                var readSuccess = function (entries) {

                    entryCount += entries.length - 1;
                    
                    _.each(entries, function (entry) {
                        if (entry.isDirectory) {
                            entry.createReader().readEntries(readSuccess);
                        } else {
                            entry.file(function (file) { fileReadSuccess(file, entry.fullPath); });
                        };
                    });

                    if (entries.length === 0) {
                        folderDefer.resolve();
                    }
                };

                var handleWebkitEntry = function (entry) {
                    
                    if (entry.isDirectory) {
                        entry.createReader().readEntries(readSuccess);
                    } else {
                        entry.file(function (file) { fileReadSuccess(file, entry.fullPath); });
                    }

                    return folderDefer.promise;
                };

                // Use FileSystem API if it's supported
                if (items && items[0] && items[0].webkitGetAsEntry) {
                    
                    var promises = [];
                    var filteredItems = _.reject(items, item => item.kind === 'string');
                    entryCount = filteredItems.length;

                    _.each(filteredItems, function (item) {
                        var entry = item.webkitGetAsEntry();
                        promises.push(handleWebkitEntry(entry));
                    });

                    $q.all(promises).then(function () { defer.resolve(files); });

                } else {
                    _.forEach(dataTransfer.files, function (file) {
                        files.push(file);
                    });
                    
                    defer.resolve(files);
                }

                return defer.promise;
            }
        }
    }
]);